module.exports = __webpack_public_path__ + "static/media/press_2.10cb7a93.jpg";